const formatTime = (date, locale) => new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: 'numeric',
}).format(new Date(date));
export function getLocalizedTime(dateStr, locale) {
    return dateStr && locale && formatTime(dateStr, locale);
}
